<div class="suif-lead-paragraph">
    We can try to recover your Account ID using your email address
</div>

<div class="suif-body-copy">
    You will receive an email letting you know if an account was found for the provided email address.
    If we find an account, the email will include your Account ID.
</div>

<form [formGroup]="lostAccountIdForm" (ngSubmit)="lostAccountIdForm.valid && submit()">
    <app-input fieldId="email-address" label="Email Address" formControlName="emailAddress" type="email" inputmode="email"
               [errors]="errors.fieldErrors.emailAddress" isRequired></app-input>

    <div class="button-row">
        <button type="button" class="btn btn-secondary" (click)="back()">Back</button>
        <app-wait-button cssClass="btn btn-verty" label="Submit" [waiting]="submitting" [isDisabled]="!lostAccountIdForm.valid"></app-wait-button>
    </div>
</form>
